/**
 * Stato di fatturazione di un rapportino, derivato dai suoi addebiti: un
 * unico flag «fatturato» non basterebbe (righe incluse, fatturabili e
 * licenze). Stessi valori per DTO, filtri del backend e webapp.
 */
export const WORK_REPORT_BILLING_STATES = [
    'NONE',
    'TO_INVOICE',
    'PARTIAL',
    /** Nessun addebito aperto, almeno uno su una fattura ancora in bozza. */
    'DRAFT_INVOICE',
    'INVOICED',
    /**
     * Stornato: gli addebiti che contano sono tutti su fatture stornate per
     * intero da nota di credito o annullate, nessuno aperto né in fattura.
     */
    'CREDITED',
];
export function isWorkReportBillingState(value) {
    return WORK_REPORT_BILLING_STATES.includes(value);
}
/**
 * Stato come lo vede chi guarda. Senza la sezione Fatture «in bozza
 * fattura» non esiste: bozze ed emesse sono entrambe «in fattura», perché
 * distinguerle direbbe lo stato di un documento che non può vedere.
 * «Stornato» resta per tutti: dice che va rifatturato, non quale fattura.
 */
export function toViewerWorkReportBillingState(state, viewer) {
    return !viewer.documents && state === 'DRAFT_INVOICE' ? 'INVOICED' : state;
}
/** Stati che chi guarda può incontrare (e filtrare), nell'ordine canonico. */
export function workReportBillingStatesFor(viewer) {
    return viewer.documents
        ? WORK_REPORT_BILLING_STATES
        : WORK_REPORT_BILLING_STATES.filter((state) => state !== 'DRAFT_INVOICE');
}
/**
 * Stati dei contratti di servizio su cui si registrano interventi e
 * licenze dei rapportini: attivi, anche con disdetta già programmata.
 */
export const WORK_REPORT_REPORTABLE_CONTRACT_STATUSES = [
    'ACTIVE',
    'CANCELLATION_SCHEDULED',
];
export function isWorkReportReportableContractStatus(status) {
    return WORK_REPORT_REPORTABLE_CONTRACT_STATUSES.includes(status);
}
//# sourceMappingURL=work-report-billing-states.js.map